module.exports = __webpack_public_path__ + "img/seat2.png";